// 質問と回答

export const questions = [
  {
    question: '休日の過ごし方は？',
    answers: [{
      text: 'お出かけしたい',
      value: 1,
    },
    {
      text: '自宅で過ごしたい',
      value: 2,
    },
    ],
  },
  {
    question: '集団で行動するのは',
    answers: [{
      text: '得意なほうだ',
      value: 3,
    },
    {
      text: '苦手なほうだ',
      value: 4,
    }
    ],
  },
  {
    question: '趣味の数は',
    answers: [{
      text: '多いほうだ',
      value: 5,
    },
    {
      text: '少ないほうだ',
      value: 6,
    },
    ],
  },
  {
    question: '物事に取り組むとき',
    answers: [{
      text: '計画を立てずまずやってみる',
      value: 7,
    },
    {
      text: '計画を立てて進めるほうだ',
      value: 8,
    },
    ],
  },
  {
    question: '困難にぶつかったら',
    answers: [{
      text: '立ち向かう',
      value: 9,
    },
    {
      text: 'すぐ諦める',
      value: 10,
    },
    ],
  },
  {
    question: '流行は掴んでおきたい',
    answers: [{
      text: '掴んでおきたい',
      value: 11,
    },
    {
      text: '流行には流されたくない',
      value: 12,
    },
    ],
  },
  {
    question: '新しいことを始めるとき',
    answers: [{
      text: '目標は高く',
      value: 13,
    },
    {
      text: '少しずつチャレンジ',
      value: 14,
    },
    ],
  },
];

export const results = [
  {
    recommend: '考えるよりまず行動！\n冒険心溢れるあなたにおすすめなはずるは…',
    name: 'はずるキャストチューブ',
    egname: 'HUZZLE CAST TUBE',
    img: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/01_cast_tube.png',
    number: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/01.svg',
    text: '見た目ではわからない構造、思いつく限り様々な方法を試そう！'
  },
  {
    recommend: '粘り強くガッツがある\nあなたにおすすめなはずるは…',
    name: 'はずるキャストインフィニティ',
    egname: 'HUZZLE CAST INFINITY',
    img: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/02_cast_infinity.png',
    number: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/02.svg',
    text: '見た目もそうだがはずすまでの動きも果てしなく続きます。でも、ガッツのあるあなたはきっと楽しめるでしょう。'
  },
  {
    recommend: '流行に敏感で好奇心溢れる\nあなたにおすすめなはずるは…',
    name: 'はずるキャストハーモニー',
    egname: 'HUZZLE CAST HARMONY',
    img: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/03_cast_harmony.png',
    number: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/03.svg',
    text: '一見パズルと思えないデザインで人気です。'
  },
  {
    recommend: '独創的な感性を持つ\nあなたにおすすめなはずるは…',
    name: 'はずるキャストUFO',
    egname: 'HUZZLE CAST UFO',
    img: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/04_cast_ufo.png',
    number: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/04.svg',
    text: '輪の中で球体が回り、どうして中に収まっているのか全く意味不明なデザイン。個性派なあなたの感性を揺さぶるかも。'
  },
  {
    recommend: '困難に挑戦することが好きな\n達成意欲の高いあなたにおすすめなはずるは…',
    name: 'はずるキャストエニグマ',
    egname: 'HUZZLE CAST ENIGMA',
    img: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/05_cast_enigma.png',
    number: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/05.svg',
    text: '「史上最も難易度が高いもののひとつ」と言われている名作。あなたもきっと挑戦したくなるはず。'
  },
  {
    recommend: 'コツコツと努力ができる\n勤勉家なあなたにおすすめなはずるは…',
    name: 'はずるキャストダイヤモンド',
    egname: 'HUZZLE CAST DIAMOND',
    img: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/06_cast_diamond.png',
    number: location.protocol + '//' + location.hostname + ':' + location.port + '/wp/wp-content/themes/hanayama/images/huzzle40/06.svg',
    text: 'はずすことは簡単でも戻すことに知恵を絞りましょう。'
  }
];

